const CommentsIcon = ({ size = 14, ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M2.87471 11.1244C4.65747 12.9074 7.29731 13.2926 9.4576 12.2935C9.77651 12.1651 10.038 12.0613 10.2865 12.0613C10.9789 12.0654 11.8407 12.7367 12.2885 12.2894C12.7364 11.8415 12.0646 10.979 12.0646 10.2825C12.0646 10.0339 12.1643 9.77709 12.2927 9.45755C13.2922 7.29761 12.9064 4.65689 11.1237 2.87453C8.84791 0.597911 5.1505 0.597911 2.87471 2.87394C0.594831 5.15408 0.598934 8.84838 2.87471 11.1244Z" 
                fill="white" 
                stroke="white" 
                strokeWidth="0.875" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M4.70217 7.24089H4.69692" 
                stroke="white" 
                strokeWidth="1.16667" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M7.04055 7.24089H7.0353" 
                stroke="white" 
                strokeWidth="1.16667" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path 
                d="M9.37893 7.24089H9.37368" 
                stroke="white" 
                strokeWidth="1.16667" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CommentsIcon;